export default __webpack_public_path__ + "static/media/add-light.f174eace.svg";